import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../../components/basic/Button'
import RightDrawer from '../../components/basic/ApplicationRightDrawer'
import LawyerImg from '../../assets/applicationFormsImgs/lawyer.svg'
import FilePicker from '../../components/basic/FilePicker'
import FileData from '../../dtos/fileData'
import {FILE_SIZE_LABEL} from "../../utils/constants";

const Home = () => {
  const navigate = useNavigate()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState<FileData[]>([])

  const handleFileSelect = async (files: File[]) => {
    setSelectedFiles(files.map(file => ({ id: 1, fileName: file.name, fileUrl: 'https://file' })))
  }
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <br /><br />
      <h1>HOME</h1>
      <br /><br />
      <Button variant='primary' onClick={() => navigate('/new')} >NEW APPLICATION</Button><br /><br />
      <br />
      <Button variant='primary' onClick={() => navigate('/policyReady')} >PROMOTE TO CUSTOMER</Button><br /><br />
      <br />
      <Button variant='primary' onClick={() => navigate('/unauthenticated?redirect=/customer/renew/begin')} >START RENEWALS</Button><br /><br />
      <br />
      <Button variant='primary' onClick={() => navigate('/unauthenticated')} >AUTHENTICATE</Button><br /><br />

      <Button onClick={() => setDrawerOpen(prev => !prev)} >Open drawer for example</Button><br /><br />
      <h1>Buttons types (no action events)</h1><br /><br />
      <div style={{margin: '0 auto', width: '500px', background: '#F9F5F2', padding: '20px'}}>
        <FilePicker 
          accept='.doc,.docx,application/msword, application/pdf'
          title={"Attorney's resume. " + FILE_SIZE_LABEL} 
          onFilesSelect={handleFileSelect} 
          selectedFiles={selectedFiles}/>
      </div>
      <br /><br />
      <Button prebuilt='back'/><br /><br />
      <Button prebuilt='next'/><br /><br />
      <Button prebuilt='saveContinue'/><br /><br />
      <Button prebuilt='saveLater'/><br /><br />
      <Button prebuilt='returnTLIE'/><br /><br />
      <Button variant='error'>Remove quote</Button><br /><br />
      <RightDrawer open={drawerOpen} toggle={() => setDrawerOpen(prev => !prev)} >
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ width: '120px', height: '120px', minWidth: '120px', minHeight: '120px', borderRadius: '50%', background: '#EBF2F2', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src={LawyerImg} alt="judge" style={{ width: '65px', height: '65px' }} />
          </div>
          <div style={{ overflow: 'auto', display: 'flex', flexDirection: 'column', marginTop: '32px' }}>
            <span style={{ color: '#937251', fontFamily: 'Tiempos', fontSize: '36px' }}>Areas of Practice</span>
            <div style={{ marginTop: '40px' }}>
              <span style={{ color: '#353744', fontWeight: 900, fontSize: '24px' }}>Real Estate</span>
              <p style={{ color: '#65666A', fontWeight: 400, fontSize: '16px', marginTop: '8px', maxWidth: '570px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip</p>
            </div>
            
            <div style={{ marginTop: '40px' }}>
              <span style={{ color: '#353744', fontWeight: 900, fontSize: '24px' }}>General Business</span>
              <p style={{ color: '#65666A', fontWeight: 400, fontSize: '16px', marginTop: '8px', maxWidth: '570px' }}> <strong>Covers areas in business other than real estate.</strong> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
            </div>
            
            <div style={{ marginTop: '40px' }}>
              <span style={{ color: '#353744', fontWeight: 900, fontSize: '24px' }}>Fiduciary</span>
              <p style={{ color: '#65666A', fontWeight: 400, fontSize: '16px', marginTop: '8px', maxWidth: '570px' }}> <strong>Covers fiduciary areas in business other than foreclosure sales.</strong> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            </div>

            <div style={{ marginTop: '40px' }}>
              <span style={{ color: '#353744', fontWeight: 900, fontSize: '24px' }}>Securities</span>
              <p style={{ color: '#65666A', fontWeight: 400, fontSize: '16px', marginTop: '8px', maxWidth: '570px' }}> <strong>Includes activites that user or contemplate the use of investor funds.</strong> onsectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
            </div>

            <div style={{ marginTop: '40px' }}>
              <span style={{ color: '#353744', fontWeight: 900, fontSize: '24px' }}>Estate, Trust, and Probate</span>
              <p style={{ color: '#65666A', fontWeight: 400, fontSize: '16px', marginTop: '8px', maxWidth: '570px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip</p>
            </div>

            <div style={{ marginTop: '40px' }}>
              <span style={{ color: '#353744', fontWeight: 900, fontSize: '24px' }}>Another Area</span>
              <p style={{ color: '#65666A', fontWeight: 400, fontSize: '16px', marginTop: '8px', maxWidth: '570px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip</p>
            </div>

            <div style={{ marginTop: '40px' }}>
              <span style={{ color: '#353744', fontWeight: 900, fontSize: '24px' }}>Another Area</span>
              <p style={{ color: '#65666A', fontWeight: 400, fontSize: '16px', marginTop: '8px', maxWidth: '570px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip</p>
            </div>

            <div style={{ marginTop: '40px' }}>
              <span style={{ color: '#353744', fontWeight: 900, fontSize: '24px' }}>Another Area</span>
              <p style={{ color: '#65666A', fontWeight: 400, fontSize: '16px', marginTop: '8px', maxWidth: '570px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip</p>
            </div>
          </div>
        </div>
      </RightDrawer>
    </div>
  )
}

export default Home